"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRequestStatuses = void 0;

var _reselect = require("reselect");

var _selectors = require("settings-content-modals/EmailCreationModal/selectors");

var getRequestStatuses = (0, _reselect.createSelector)(_selectors.getModalSelector, function (state) {
  return state.requests;
});
exports.getRequestStatuses = getRequestStatuses;